import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import SbEditable from "storyblok-react";
import Avatar from "~components/molecules/avatar/avatar";
import BackgroundImage from "~components/molecules/background_image/background_image";
import { BLOK_ARRAY } from "../../../../prop_types";
import {
  authorNameStyle,
  clientLogoStyle,
  quoteAttributionStyle,
  quoteBodyStyle,
  textColorDarkStyle,
  textColorLightStyle,
} from "./quote_block.module.scss";

export default function QuoteBlock({
  quoteBody,
  quoteAttribution: quoteAttributionArray,
  theme,
  size,
  isCentered,
  hasBlockQuoteStyle,
  ...rest
}) {
  const [quoteAttribution] = quoteAttributionArray || [];
  const quoteBodyClassNames = classNames(quoteBodyStyle, {
    [textColorDarkStyle]: theme === "dark",
    [textColorLightStyle]: theme === "light",
  });

  if (quoteBody || quoteAttribution) {
    return (
      <SbEditable content={rest}>
        <blockquote className={quoteBodyClassNames} data-testid="quote">
          {quoteBody && <p>{quoteBody}</p>}
          {quoteAttribution && (
            <SbEditable content={{ ...quoteAttribution }}>
              <div
                className={quoteAttributionStyle}
                data-testid="quote-attribution"
              >
                {quoteAttribution.authorAvatar.length > 0 && (
                  <Avatar {...quoteAttribution.authorAvatar[0]} width={64} />
                )}
                <div>
                  {quoteAttribution.authorName && (
                    <span
                      className={authorNameStyle}
                      data-testid="quote-attribution-author-name"
                      itemProp="name"
                    >
                      {quoteAttribution.authorName}
                      {quoteAttribution.authorName &&
                        quoteAttribution.authorRole &&
                        ", "}
                    </span>
                  )}
                  {quoteAttribution.authorRole && (
                    <span
                      data-testid="quote-attribution-author-role"
                      itemProp="jobTitle"
                    >
                      {quoteAttribution.authorRole}
                    </span>
                  )}
                  {quoteAttribution.clientLogo.length > 0 && (
                    <div className={clientLogoStyle} data-testid="client-logo">
                      <BackgroundImage
                        {...quoteAttribution.clientLogo[0]}
                        width={null}
                        horizontalAlign="left"
                      />
                    </div>
                  )}
                </div>
              </div>
            </SbEditable>
          )}
        </blockquote>
      </SbEditable>
    );
  }
  return null;
}

QuoteBlock.defaultProps = {
  quoteBody: null,
  quoteAttribution: null,
  size: "medium",
  theme: "dark",
  isCentered: false,
  hasBlockQuoteStyle: false,
};

QuoteBlock.propTypes = {
  quoteBody: PropTypes.string,
  quoteAttribution: BLOK_ARRAY,
  size: PropTypes.string,
  theme: PropTypes.string,
  isCentered: PropTypes.bool,
  hasBlockQuoteStyle: PropTypes.bool,
};
